// extracted by mini-css-extract-plugin
module.exports =  {"root":"Rm4BFFR522ThtcB07HBW","budgetInput":"lwlvQA1VQ5JbWLHMYOdi","marginBuster":"WWFhGcNQRqhTJuCp9_Ms"};